import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { compact } from 'lodash-es';
import { Typography } from 'seagull';
import DigitalSignature from '~/components/DigitalSignature/DigitalSignature';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { relationshipModel, timeModel } from '~/models';
import { getSortedFormattedDigitalSignatures } from '~/pages/AgreementMinisite/AgreementView/AgreementView.utils';
import { AgreementViewCard, Logo, TopStripe } from './CommonComponents';
import styles from './SignedHeader.module.scss';
const DetailsText = (props)=>/*#__PURE__*/ _jsx(Typography, _object_spread({
        ellipsis: true,
        skin: "secondary"
    }, props));
export default function SignedHeader(param) {
    let { relationship, brandColor, testPrefix } = param;
    const { t: viewTexts } = useLocaleKeys('pages.agreementMinisite.agreementView');
    const { CLIENT_ONBOARDING_NEW_FLOW } = useFeatureFlags();
    const vendorLogoUrl = relationshipModel.vendorLogoUrl(relationship);
    return /*#__PURE__*/ _jsxs(AgreementViewCard, {
        className: cn(styles.signedHeader, {
            [styles.withLogo]: vendorLogoUrl
        }),
        children: [
            /*#__PURE__*/ _jsx(TopStripe, {
                backgroundColor: brandColor
            }),
            vendorLogoUrl && /*#__PURE__*/ _jsx(Logo, {
                logoUrl: vendorLogoUrl
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.datesContainer,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "h6",
                    children: viewTexts.agreementBetween()
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.contactDetailsContainer,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(DetailsText, {
                                testId: testPrefix + 'seller-name',
                                children: relationshipModel.sellerFullName(relationship)
                            }),
                            /*#__PURE__*/ _jsx(DetailsText, {
                                testId: testPrefix + 'vendor-name',
                                children: relationshipModel.vendorName(relationship)
                            }),
                            /*#__PURE__*/ _jsx(DetailsText, {
                                testId: testPrefix + 'seller-email',
                                children: relationshipModel.sellerEmail(relationship)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(DetailsText, {
                                testId: testPrefix + 'buyer-`name',
                                children: relationshipModel.buyerFullName(relationship)
                            }),
                            /*#__PURE__*/ _jsx(DetailsText, {
                                testId: testPrefix + 'customer-name',
                                children: relationshipModel.customerName(relationship)
                            }),
                            /*#__PURE__*/ _jsx(DetailsText, {
                                testId: testPrefix + 'buyer-email',
                                children: relationshipModel.buyerEmail(relationship)
                            })
                        ]
                    })
                ]
            }),
            relationshipModel.isApproved(relationship) && relationship.approvalRecord ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        variant: "paragraph2",
                        skin: "secondary",
                        testId: "digital-signature-block-when",
                        children: [
                            viewTexts.digitallySignedBy(),
                            !CLIENT_ONBOARDING_NEW_FLOW && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("br", {})
                                ]
                            })
                        ]
                    }),
                    getSortedFormattedDigitalSignatures(relationship.approvalRecord, compact(relationship.additionalApprovalRecords)).map((formattedDigitalSignature)=>/*#__PURE__*/ _jsx(DigitalSignature, {
                            formattedDigitalSignature: formattedDigitalSignature
                        }, formattedDigitalSignature.on + formattedDigitalSignature.ip))
                ]
            }) : CLIENT_ONBOARDING_NEW_FLOW ? /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                skin: "secondary",
                testId: "externally-signed-indicator",
                children: viewTexts.agreementUploadedOnAnchorBy({
                    sellerName: relationshipModel.sellerFullName(relationship),
                    date: timeModel.formatDateWithTimeShortMonth(relationship.createdOn, true)
                })
            }) : /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                skin: "secondary",
                testId: "externally-signed-indicator",
                children: viewTexts.existingAgreementUploadedAndAuthorized({
                    sellerName: relationshipModel.sellerFullName(relationship),
                    date: timeModel.formatDateWithTime(relationship.createdOn)
                })
            })
        ]
    });
}
